import React from "react";
import { observer } from "mobx-react";
import SurveyCondensedTable from "../../../SurveyCondensedTable";
import { NumberFormat, PlaceholderFormat } from "../../../../Enums/constants";
import { handleValidationData } from "./ValidationTableHandler";

const ValidationTable = observer((props) => {
    let currencyPlaceHolderThousandForHeader = `|${PlaceholderFormat.CURRENCY_THOUSAND}|`;

    return (
        <SurveyCondensedTable tableName={"ValidationTable"}
            handleData={handleValidationData}
            noButton
            styleOverride={{ marginTop: '5px' }}
            headers={["FeeType", "Reported", "Imputed Costs", "Total"]}
            columns={[
                { data: 'FeeType', readOnly: true },
                { data: 'Reported', readOnly: true },
                { data: 'Default', readOnly: true },
                { data: 'Total', readOnly: true }
            ]}
            colWidths={['250px', '150px', '150px', '150px']}
            formatting={['', NumberFormat.MONEYTHOUSAND, NumberFormat.MONEYTHOUSAND, NumberFormat.MONEYTHOUSAND]}
            nestedHeaders={[
                ["",
                    `Reported<br />${currencyPlaceHolderThousandForHeader}`,
                    `Imputed Costs<br />${currencyPlaceHolderThousandForHeader}`,
                    `Total<br />${currencyPlaceHolderThousandForHeader}`]
            ]} />
    );

});
export default ValidationTable;

